import React from 'react';
import { FiMenu } from 'react-icons/fi';
import resume from '../../Assets/Syeda_Aisha-Ahmad_Resume_07-10-2023-22-27-42.pdf'
import './Nav.css'

const Nav = () => {
    return (
        <div className="navbar mt-5 text-lg text-gray-700 font-semibold lg:max-w-[1400px] mx-auto px-5" data-aos="fade-down">
            {/* Small and medium Device */}
            <div className="navbar-start w-screen lg:w-full flex justify-between">
                <a href='/' className="normal-case text-2xl font-bold text-neutral">S.Aisha</a>
                <div className="dropdown">
                    <ul tabIndex={0} className="menu menu-compact right-0 top-10 dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                        <li className='hover:text-primary'><a href='#about' className='hover:bg-base-100'>About</a></li>
                        <li className='hover:text-primary'><a href='#experience' className='hover:bg-base-100'>Experience</a></li>
                        <li className='hover:text-primary'><a href='#skills' className='hover:bg-base-100'>Skills</a></li>
                        <li className='hover:text-primary'><a href='#work' className='hover:bg-base-100'>Work</a></li>
                        <li className='hover:text-primary'><a href='#contact' className='hover:bg-base-100'>Contact</a></li>
                        <li className='hover:text-primary bg-secondary mx-3 rounded-full' ><a href={resume} className="hover:text-white text-white " download>
                            <span className='text-white text-center hover:text-white'>Resume</span>
                        </a></li>
                    </ul>
                    <div className='mr-auto'>
                        <label tabIndex={0} className="btn btn-ghost text-2xl text-neutral lg:hidden">
                            <FiMenu />
                        </label>
                    </div>
                </div>

            </div>

            <a href='/' className="hidden btn bg-base-100 text-neutral hover:text-primary hover:bg-base-100 border-none normal-case text-[27px] font-bold md:hidden">S.Aisha</a>

            {/* Large device */}
            <div className="navbar-end w-full hidden lg:flex ">
                <ul className="menu menu-horizontal px-1 flex items-center gap-5">
                    <li className='hover:text-primary'><a href='#about' className='hover:bg-base-100 text-base'>About</a></li>
                    <li className='hover:text-primary'><a href='#experience' className='hover:bg-base-100 text-base'>Experience</a></li>
                    <li className='hover:text-primary'><a href='#skills' className='hover:bg-base-100 text-base'>Skills</a></li>
                    <li className='hover:text-primary'><a href='#work' className='hover:bg-base-100 text-base'>Work</a></li>
                    <li className='hover:text-primary'><a href='#contact' className='hover:bg-base-100 text-base'>Contact</a></li>
                    <div className='bg-secondary text-white hover:bg-primary lg:rounded-full py-1 px-7 ml-2'>
                        <a href={resume} className="hover:text-white text-white" download>
                            <span className='text-white hover:text-white'>Resume</span>
                        </a>
                    </div>
                </ul>
            </div>
        </div>
    );
};

export default Nav;